document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const from = params.get('from');
  if (!from) return;

  const fromTs = Math.floor(new Date(from).getTime() / 1000);

  const applyFilter = () => {
    document.querySelectorAll('[data-created-at]').forEach(card => {
      const ts = parseInt(card.dataset.createdAt, 10);
      if (ts < fromTs) {
        card.style.display = 'none';
      }
    });
  };

  applyFilter();

  // Re-run after infinite scroll loads more products
  const observer = new MutationObserver(applyFilter);
  observer.observe(document.querySelector('#ResultsList'), {
    childList: true,
    subtree: true,
  });
});